module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_0.cff50511.png";